import React from 'react'
import PropTypes from 'prop-types'
import { Panel, ListGroup, Button } from 'react-bootstrap'
import NoticeEditor from './NoticeEditor'
import NoticeItem from './NoticeItem'
import { rest, utils } from '../../lib'
import { HOST, EVENT } from '../../lib/constants'

const url = `${HOST}/rest/notice`

class NoticeView extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      notices: [],
      selected: {},
      editable: true,
      showEditor: false
    }
  }

  componentDidMount = () => {
    this._isMounted = true
    this.fetchNotice()
  }
  componentWillUnmount = () => this._isMounted = false

  fetchNotice = () => rest.post(url+'/list', utils.json({ type: EVENT.SITE, num: this.props.max })).then(
    res => this._isMounted && res.events && this.setState({ notices: res.events })
  )
  removeNotice = notice => rest.post(url+'/remove', utils.json(notice)).then(
    res => this._isMounted && res.status === 'success' && this.fetchNotice()
  )

  handleInsert = () => this.setState({ selected: {author: this.props.user.name, type: EVENT.SITE, created: new Date().toISOString()}, editable: true, showEditor: true })
  handleItemClick = (notice, action) => {
    switch(action) {
      case 'view':    return this.setState({ selected: notice, editable: false, showEditor: true })
      case 'edit':    return this.setState({ selected: notice, editable: true, showEditor: true })
      case 'remove':  return this.removeNotice(notice)
      default:        return this.setState({ selected: notice, editable: false, showEditor: true })
    }
  }
  onEditorClose = isUpdated => {
    this.setState({ showEditor: false })
    if (isUpdated) this.fetchNotice()
  }
  itemEditable = notice => (notice.author && notice.author === this.props.user.name) || this.props.user.auth === 0

  render() {
    const { notices, selected, editable, showEditor } = this.state

    return (
      <div className='panel'>
        <Panel.Heading>
          <Panel.Title>
            Site News
            <div className='panel-heading-controls'>
              <Button bsSize='xsmall' bsStyle='info' onClick={this.handleInsert}>New</Button>
            </div>
          </Panel.Title>
        </Panel.Heading>
        <ListGroup >
          { notices.length > 0 && notices.map( (o, i) => <NoticeItem key={i} notice={o} onItemClick={this.handleItemClick} editable={this.itemEditable(o)}/> ) }
        </ListGroup>
        <NoticeEditor notice={selected} editable={editable} show={showEditor} onFinish={this.onEditorClose}/>
      </div>
    )
  }
}

NoticeView.defaultProps = {
  max: 10,
}

NoticeView.propTypes = {
  max: PropTypes.number,
}

export default NoticeView



// WEBPACK FOOTER //
// ./src/components/widgets/NoticeView.js